import { Component } from 'react';

import styles from './Part11Indicator.scss';

class Part11Indicator extends Component {
    render() {
        const { className } = this.props;

        return (
            <span className={`${styles.icon} ${className}`} data-cy="Part11Indicator"></span>
        );
    }
}

export default Part11Indicator;
